import { Suspense } from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'

import { RouteSkeleton } from '@/shared/components/RouteSkeleton'

/**
 * Raíz de todas las rutas. `ScrollRestoration` (del data router) lleva el scroll
 * arriba al navegar a una página nueva y lo restaura al volver atrás/adelante; sin
 * él, la SPA conservaba la altura de la página anterior al cambiar de ruta.
 */
export function SuspenseShell() {
  return (
    <>
      <ScrollRestoration />
      <Suspense fallback={<RouteSkeleton />}>
        <Outlet />
      </Suspense>
    </>
  )
}
